/**
 * Module-level state for tracking credential upgrade flow initiation.
 * This variable resets to false on every page load (including refreshes),
 * allowing us to distinguish between:
 * - Initial login where credential upgrade is needed (set to true in Login.utils before components mount)
 * - Page refresh attempting to bypass (variable resets to false, no components mount yet)
 */
let credentialUpgradeFlowActive = false;

/**
 * Called by Login.utils when credential upgrade is required, BEFORE any components mount.
 * Marks that the credential upgrade flow is active for this specific page load.
 * This prevents RedirectForCredentialUpgrade from logging out during initial login.
 */
export function markCredentialModalRendered(): void {
    credentialUpgradeFlowActive = true;
}

/**
 * Checks if the credential upgrade flow is active in the current page load.
 * Returns false on page refresh (module reloads, variable resets to false).
 */
export function hasCredentialModalRendered(): boolean {
    return credentialUpgradeFlowActive;
}
